import React from "react";
// import { Link } from "react-router-dom";
import { HashLink as Link } from "react-router-hash-link";
import styles from "./../style/footer.module.css";
import { ReactComponent as LinkedinIcon } from './../assets/icons/linkedin.svg';

const Footer = () => {
  return (
    <div className={styles.footerContent}>
      <div className={styles.footerSection}>
        <div className={styles.footerSectionTitle}>PARTNERING</div>
        <div className={styles.footerSectionContent}>
          <div><Link to="/Partnering#partnering">Collaborations and technology licensing </Link></div>
        </div>
      </div>
      <div className={styles.footerSection}>
        <div className={styles.footerSectionTitle}>SCIENCE / INNOVATION</div>
        <div className={styles.footerSectionContent}>
          <div><Link to="/bd#multiplex">Multiplex engineering platform</Link></div>
          <div><Link to="/bd#publications">Scientific publications</Link></div>
        </div>
      </div>
      <div className={styles.footerSection}>
        <div className={styles.footerSectionTitle}>COMPANY POLICY</div>
        <div className={styles.footerSectionContent}>          
          <div>
            <a
            href="/policies/docs/GEP_Antion.pdf" 
              target="_blank" 

              rel="noopener noreferrer"
              className={styles.policyLink}
            >
              Gender Equality Plan
            </a>
          </div>
        </div> 
      </div>
       <div className={styles.footerSection}>
        <div className={styles.footerSectionTitle}>FOLLOW US</div>
        <div className={styles.footerSectionContent}>
          <div>
            <a
            href="https://www.linkedin.com/company/antion-biosciences/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Antion Biosciences on LinkedIn"
          >
            <LinkedinIcon className={styles.newsIcon} />
          </a>
          </div>
        </div>
      </div>  
      <div className={styles.footerSection}>
        <div className={styles.footerSectionTitle}>CONTACT US</div>
        <div className={styles.footerSectionContent}>
          <div className={styles.visitUsContent}>
            Antion Biosciences SA<br />
            Chemin des Aulx 12, CTN12<br />
            1228 Plan-les-Ouates<br />
            Switzerland<br />
            <br />
            <a href="mailto:info@antionbio.com">
            info@antionbio.com
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer